import { Divider, FormControlLabel } from '@material-ui/core';
import React from 'react';
import InputMouseAction, {
	InputMouseActionEventProps,
} from '../../../../../../../../../reusable/InputMouseAction/InputMouseAction';
import { useTranslation } from 'react-i18next';
import { WIDGET_TYPE_IFRAME } from '../../../../../../../../../constants/scenarioConstant';

interface PositionProps extends InputMouseActionEventProps {
	x: number;
	y: number;
	w: number;
	h: number;
	rotation: number;
	type: string;
}

const Position = ({
	x,
	y,
	w,
	h,
	rotation,
	type,
	handleLocationAttributeChange,
	handleMouseActionSelectInput,
	handleOnMouseMove,
	handleOnMouseUp,
}: PositionProps) => {
	const { t } = useTranslation();
	return (
		<>
			<Divider className="divider-extra-space" />

			<FormControlLabel
				className={'scenario-chart__control'}
				control={
					<div className="scene-widgets__sort-input-control">
						<InputMouseAction
							value={x}
							styleProperty="coordinate"
							valueProperty="x"
							handleLocationAttributeChange={handleLocationAttributeChange}
							handleMouseActionSelectInput={handleMouseActionSelectInput}
							handleOnMouseMove={handleOnMouseMove}
							handleOnMouseUp={handleOnMouseUp}
						/>
						<InputMouseAction
							value={y}
							styleProperty="coordinate"
							valueProperty="y"
							handleLocationAttributeChange={handleLocationAttributeChange}
							handleMouseActionSelectInput={handleMouseActionSelectInput}
							handleOnMouseMove={handleOnMouseMove}
							handleOnMouseUp={handleOnMouseUp}
						/>
					</div>
				}
				label={t('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_POSITION')}
				labelPlacement="start"
			/>
			<FormControlLabel
				className={'scenario-chart__control'}
				control={
					<div className="scene-widgets__sort-input-control">
						<InputMouseAction
							value={w}
							styleProperty="dimension"
							valueProperty="w"
							handleLocationAttributeChange={handleLocationAttributeChange}
							handleMouseActionSelectInput={handleMouseActionSelectInput}
							handleOnMouseMove={handleOnMouseMove}
							handleOnMouseUp={handleOnMouseUp}
						/>
						<InputMouseAction
							value={h}
							styleProperty="dimension"
							valueProperty="h"
							handleLocationAttributeChange={handleLocationAttributeChange}
							handleMouseActionSelectInput={handleMouseActionSelectInput}
							handleOnMouseMove={handleOnMouseMove}
							handleOnMouseUp={handleOnMouseUp}
						/>
					</div>
				}
				label={t('COMMON_SIZE')}
				labelPlacement="start"
			/>
			{type !== WIDGET_TYPE_IFRAME && (
				<FormControlLabel
					className={'scenario-chart__control'}
					control={
						<div className="scene-widgets__sort-input-control">
							<InputMouseAction
								value={rotation}
								styleProperty="rotation"
								handleLocationAttributeChange={handleLocationAttributeChange}
								handleMouseActionSelectInput={handleMouseActionSelectInput}
								handleOnMouseMove={handleOnMouseMove}
								handleOnMouseUp={handleOnMouseUp}
							/>
						</div>
					}
					label={t('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_ROTATION')}
					labelPlacement="start"
				/>
			)}
		</>
	);
};

export default Position;
